import { Routes } from '@angular/router';
import { PublicLayoutComponent } from '@layouts/public-layout/components/public-layout/public-layout.component';
import { utmPersistenceGuard } from './modules/shipment-record/utm-persistence.guard';

export const routes: Routes = [
    {
        path: '',
        component: PublicLayoutComponent,
        loadChildren: () => import('./modules/home/home.routes').then((m) => m.default)
    },
    {
        path: 'shipment-record',
        component: PublicLayoutComponent,
        canActivateChild: [utmPersistenceGuard],
        loadChildren: () => import('./modules/shipment-record/shipment-record.routes').then((m) => m.default)
    },
    {
        path: '**',
        redirectTo: ''
    }
];
